import React from 'react';
import { useTranslation, Trans } from "react-i18next";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  PointElement,
  Legend,
  LineElement,
  Filler,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {
  useTheme, Box, Typography
} from '@mui/material'
import FilterButton from 'components/FilterButton';
import constants from 'assets/constants'
import { useChartData } from 'assets/utils';
import { disp_rank_short } from 'assets/utils';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  Title,
  Filler,
  Tooltip,
  Legend,
  PointElement
);

export const options = (sum, t) => ({
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
        callbacks: {
            title: (v) => v[0]["label"] + " " + t("common.pts"),
            footer: (v) => t("common.total") + ": " + sum
        }
    }
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
  scales: {
    y: {
        maxRotation: 0,
      display: false
    },
    x: {
      grid: {
        display: false,
      },
      //ticks: {
      //  maxRotation: 0
      //}
    }
  },
});

function mapKeys(data, category) {
    if (category === undefined || category.length === 1) {
        return data
    } else {
        return data.map(el => disp_rank_short(el, category))
    }
    
}

//const labels = ['P50', 'P100', 'P200', 'P300', 'P400', 'P500', 'P700', 'P1000'];
const labels = Object.values(constants["FILTERS"]["RANK"]);
const pyramids = constants["FILTERS"]["PYRAMID"]
export default function ActivePlayersChart() {

  const theme = useTheme()
  const { t } = useTranslation()
  const data = useChartData()["active_players"];

  const [filter, setFilter] = React.useState(undefined);
  const filterTag = pyramids[filter];

  const chartData = {
    labels: data ? mapKeys(Object.keys(data[filterTag ? filterTag:"base"]), filterTag) : labels,
    datasets: [
      {
        label: filter ? t("filters.pyramid." + pyramids[filter]) : t("common.players"),
        data: data ? Object.values(data[filterTag ? filterTag:"base"]) : [],
        backgroundColor: theme.palette.primary.main,
        borderRadius: 5,
      },
    ],
  
  };

  const sum = data ? Object.values(data[filterTag ? filterTag:"base"]).reduce((a,v) =>  a = a + parseInt(v) , 0 ) : 0;

  return <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", pt: 4}}>
        <FilterButton variant="text" sx={{fontWeight: "700", letterSpacing: '0.0075em', alignSelf: "flex-start", pr: 1, pl: 0, mx: 0, fontSize: "1.25rem", color: theme => theme.palette.text.primary_bold}} name={t("activePlayers.title")} values={pyramids} value={filter} setValue={setFilter} getLabel={(v) => t("filters.pyramid." + v)} />

        <Typography variant="body" color="text.primary_bold" component="div" sx={{mb: 2}} >
            <Trans
              i18nKey="activePlayers.summary"
              values={{ count: sum }}
              components={{ bold: <b /> }}
            /> 
        </Typography>

    <Bar options={options(sum, t)} data={chartData} />
      
  </Box>;
}
